import { createAction } from '/@/store/utils';

export const setNotifications = createAction('NOTIFICATIONS:SET_NOTIFICATIONS');
export const setReadedNotifications = createAction('NOTIFICATIONS:SET_READED_NOTIFICATIONS');
export const setUnreadedNotifications = createAction('NOTIFICATIONS:SET_UNREADED_NOTIFICATIONS');
